import React from 'react'
import Modal from '@components/common/Modal';
import { closeErrorPopup } from '@reducers/notification';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TouchableButton } from '@components/common/Touchable';

const ErrorPopup = ({
    isOpen,
    errorMsg,
    ...props
}) => {
  return (
    <div> 
        <Modal isOpen={isOpen} isModalCenter customClass="p-3">
           <div className='col-12 p-3 d-flex justify-content-center align-items-center text-center od-text-primary text-primary'>
              <div className='col-12 p-0'>
                 <div className='col-12 py-2 fs-28 fw-600 text-center'>{errorMsg}</div>
                 <div className='col-12 px-0 mt-2 d-flex justify-content-center align-items-center'>
                      <TouchableButton className='col-4 px-0 btn btn-primary btn-ripple btn-lg od-btn-primary fs-18' onClick={(event) =>{event.preventDefault(); props.closeErrorPopup()}}>OK</TouchableButton>
                 </div>
              </div>
           </div> 
        </Modal>
    </div>
  )
}

const mapStateToProps = ({notification}) => ({
    isOpen: notification.isErrorPopUp,
    errorMsg: notification.errorMsg
});
const mapDispatchToProps = (dispatch) => bindActionCreators({
closeErrorPopup
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ErrorPopup);
